/* ============================================
   HAYEON — JavaScript
   Side panel · Tabs · Cart count
   (Add-to-cart handled by native Shopify forms)
   ============================================ */

/* ---- SIDE PANEL ---- */
function openPanel() {
  document.getElementById('sidePanel').classList.add('open');
  document.getElementById('sidePanelOverlay').classList.add('open');
  var btn = document.getElementById('hamburgerBtn');
  if (btn) btn.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
}

function closePanel() {
  document.getElementById('sidePanel').classList.remove('open');
  document.getElementById('sidePanelOverlay').classList.remove('open');
  var btn = document.getElementById('hamburgerBtn');
  if (btn) btn.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') closePanel();
});

/* ---- RITUAL TABS ---- */
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.dataset.target;

      btn.closest('.ritual-tabs').querySelectorAll('.tab-btn').forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.ritual-panel').forEach(function (p) {
        p.classList.remove('active');
      });

      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  /* ---- CART COUNT (bubble on header icon) ---- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cartCount');
        if (el) {
          if (cart.item_count > 0) {
            el.textContent = cart.item_count;
            el.classList.add('visible');
          } else {
            el.classList.remove('visible');
          }
        }
      })
      .catch(function () {});
  }

  updateCartCount();

  /* Refresh cart count after add-to-cart form submit */
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      setTimeout(updateCartCount, 800);
    });
  });

  /* ---- HEADER SCROLL SHADOW ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 20
        ? '0 1px 20px rgba(28,28,26,0.08)'
        : 'none';
    }, { passive: true });
  }

});

/* ---- STICKY ANNOUNCEMENT BAR ---- */
(function () {
  var bar = document.getElementById('hayeonStickyBar');
  if (!bar) return;

  // Check if user dismissed this session
  if (sessionStorage.getItem('hayeon-bar-dismissed')) {
    bar.style.display = 'none';
    return;
  }

  document.body.classList.add('has-sticky-bar');

  // Hide bar on scroll down, show on scroll up
  var lastScroll = 0;
  var scrollThreshold = 80;

  window.addEventListener('scroll', function () {
    var current = window.scrollY;
    if (current > lastScroll && current > scrollThreshold) {
      bar.classList.add('hidden');
    } else {
      bar.classList.remove('hidden');
    }
    lastScroll = current;
  }, { passive: true });
})();

function dismissStickyBar() {
  var bar = document.getElementById('hayeonStickyBar');
  if (bar) {
    bar.style.display = 'none';
    document.body.classList.remove('has-sticky-bar');
    sessionStorage.setItem('hayeon-bar-dismissed', '1');
  }
}

/* ---- V7: HERO RIGHT → CLICKABLE ---- */
document.addEventListener('DOMContentLoaded', function () {
  var heroRight = document.querySelector('.hero-right');
  if (heroRight) {
    // Inject CTA overlay
    var overlay = document.createElement('div');
    overlay.className = 'hero-right-cta-overlay';
    overlay.innerHTML = '<span class="hero-right-cta-label">Discover the rituals</span>' +
      '<div class="hero-right-cta-arrow"><svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg></div>';
    heroRight.appendChild(overlay);

    // Make entire right panel clickable
    // Priority: data-url attribute → /collections/all (safe fallback that always exists)
    heroRight.addEventListener('click', function (e) {
      // Don't trigger if user clicked a button/link inside
      if (e.target.closest('button, a')) return;
      var url = heroRight.getAttribute('data-url');
      if (!url || url === 'null' || url.trim() === '') {
        url = '/collections/all';
      }
      window.location.href = url;
    });

    // Keyboard accessibility
    heroRight.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var url = heroRight.getAttribute('data-url') || '/collections/all';
        window.location.href = url;
      }
    });
  }

  /* ---- ACCORDION ---- */
  document.querySelectorAll('.hayeon-accordion-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var acc = btn.closest('.hayeon-accordion');
      acc.classList.toggle('open');
      btn.setAttribute('aria-expanded', acc.classList.contains('open'));
    });
  });
});

/* ---- V7.2: PRODUCT TAG INJECTION ---- */
(function () {
  var tagsMap = [
    { match: /sulwhasoo|cleansing foam/i,               tags: 'Botanical cleanser · Hydrating' },
    { match: /matrixyl|boosting shot/i,                 tags: 'Matrixyl 3000® · Peptides 10%' },
    { match: /medicube|pdrn|collagen capsule/i,         tags: 'Salmon PDRN · Collagen · Niacinamide' },
    { match: /toning toner|centella toning/i,           tags: 'Centella · PHA · Hyaluronic acid' },
    { match: /eye serum|revive eye|ginseng.*retinal/i,  tags: 'Retinal 2% · Ginseng saponins' },
    { match: /centella ampoule|skin1004 ampoule/i,      tags: 'Centella Asiatica · Barrier repair' },
    { match: /illiyoon|ceramide ato/i,                  tags: 'Ceramides · Barrier repair' },
    { match: /aestura.*foaming|foaming cleanser/i,        tags: 'Gentle cleanser · pH-balanced' },
    { match: /torriden.*dive|dive.in serum/i,           tags: '5D Hyaluronic Acid · Deep hydration' },
    { match: /aestura.*365|365 cream/i,                 tags: 'Soothing' },
    { match: /clinfinite|rice cleanser/i,               tags: 'Fermented rice · Brightening' },
    { match: /laneige.*cream skin|cream skin/i,         tags: 'Amino acids · Tea extract' },
    { match: /boj.*glow|glow serum.*propolis/i,         tags: 'Propolis · Niacinamide · Glow' },
    { match: /boj.*ginseng.*cleansing|ginseng cleansing oil/i, tags: 'Ginseng · Deep cleanse' },
    { match: /mary.?may.*idebenone|idebenone cream/i,   tags: 'Idebenone · Antioxidant' }
  ];

  function inject() {
    document.querySelectorAll('.hrl-product-item-tags[data-tags]').forEach(function (el) {
      if (el.textContent.trim()) return; // already populated

      var button = el.closest('.hrl-product-item');
      var nameEl = button ? button.querySelector('.hrl-product-item-name') : null;
      if (!nameEl) return;

      var name = nameEl.textContent.trim();
      for (var i = 0; i < tagsMap.length; i++) {
        if (tagsMap[i].match.test(name)) {
          el.textContent = tagsMap[i].tags;
          break;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  // Also re-run when tabs change
  setTimeout(inject, 500);
})();

/* ---- V7.6: RITUAL MENU ACCORDIONS ---- */
(function () {
  function initRitualMenus() {
    document.querySelectorAll('[data-ritual-accordion]').forEach(function (menu) {
      var trigger = menu.querySelector('.hrl-ritual-menu-trigger');
      var body = menu.querySelector('.hrl-ritual-menu-body');
      if (!trigger || !body) return;

      if (trigger.dataset.ritualBound) return;
      trigger.dataset.ritualBound = '1';

      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !expanded);
        if (!expanded) {
          body.setAttribute('data-open', 'true');
        } else {
          body.removeAttribute('data-open');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRitualMenus);
  } else {
    initRitualMenus();
  }

  // Re-bind once after any late DOM insertion (theme editor, async sections)
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { initRitualMenus(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 3000);
  } else {
    setTimeout(initRitualMenus, 600);
  }
})();

/* ---- V7.7: PRODUCT COUNT SYNC (Essential/Absolute) ---- */
(function () {
  function updateCount(scope) {
    var root = scope || document;
    // Find each ritual panel
    root.querySelectorAll('.hrl-panel').forEach(function (panel) {
      var countEl = panel.querySelector('.hrl-ritual-menu-count[data-count-essential]');
      if (!countEl) return;

      var activeBtn = panel.querySelector('.hrl-version-btn--active');
      var version = activeBtn ? activeBtn.getAttribute('data-version') : 'absolute';
      var target = version === 'essential'
        ? countEl.getAttribute('data-count-essential')
        : countEl.getAttribute('data-count-absolute');

      if (target && countEl.textContent.trim() !== target) {
        countEl.textContent = target;
      }
    });
  }

  function bindVersionButtons() {
    document.querySelectorAll('.hrl-version-btn').forEach(function (btn) {
      if (btn.dataset.countBound) return;
      btn.dataset.countBound = '1';
      btn.addEventListener('click', function () {
        // Let the theme's own handler update the active class first
        setTimeout(function () { updateCount(); }, 20);
      });
    });
  }

  function init() {
    updateCount();
    bindVersionButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Rebind after any late renders
  if (window.MutationObserver) {
    var mo2 = new MutationObserver(function () { init(); });
    mo2.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo2.disconnect(); }, 3000);
  } else {
    setTimeout(init, 600);
  }
})();
